import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'keys', standalone: false})
export class KeysPipe implements PipeTransform {
    transform(value, args?: string[]): any {
        const entries = [];
        if (value) {
            for (const key of Object.keys(value)) {
                entries.push({key: key, value: value[key]});
            }
        }
        return entries;
    }
}
